import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Clapperboard, Loader2, Wand2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const LABELS = { reloc: "relocation product", guide: "town guide product", pack: "pack", compare: "comparison" };

export const MissingShorts = () => {
  const [s, setS] = useState(null);
  const load = useCallback(() => api.get("/video-prompts/missing").then((r) => setS(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (!s?.running) return undefined; const t = setInterval(load, 5000); return () => clearInterval(t); }, [s?.running, load]);
  if (!s) return null;
  const start = async () => {
    if (!window.confirm(`Write sales shorts for ${s.missing} products that don't have them yet? Each uses a little AI credit.`)) return;
    try { const r = await api.post("/video-prompts/missing"); setS({ ...s, ...r.data }); toast.success(`Writing shorts for ${r.data.total} products, two at a time`); } catch (e) { toast.error(errMsg(e)); }
  };
  const parts = Object.entries(s.by_kind || {}).filter(([, n]) => n).map(([k, n]) => `${n} ${LABELS[k]}${n > 1 ? "s" : ""}`).join(" · ");
  return (
    <div className="border border-[#E2D9CC] bg-[#FAF7F2] p-5 mb-16 flex flex-wrap items-center gap-4" data-testid="missing-shorts">
      <Clapperboard className="w-5 h-5 text-[#C59B27]" strokeWidth={1.5} />
      <div className="mr-auto">
        <p className="eyebrow mb-1">Video sales shorts</p>
        {s.running
          ? <p className="text-sm" data-testid="missing-shorts-progress">Writing… {s.done} of {s.total} products done{s.failed ? `, ${s.failed} failed` : ""}</p>
          : <p className="text-sm text-[#8C827A]" data-testid="missing-shorts-count">{s.missing ? `${s.missing} products without shorts: ${parts}` : "Every product has its shorts."}{s.total && !s.running ? ` Last run: ${s.done - s.failed} of ${s.total} written.` : ""}</p>}
      </div>
      <Button onClick={start} disabled={s.running || !s.missing} className="rounded-none" data-testid="missing-shorts-button">
        {s.running ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Wand2 className="w-4 h-4 mr-2" />}{s.running ? "Writing shorts…" : "Write missing shorts"}
      </Button>
    </div>
  );
};
